var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{ref:"donut",staticClass:"chart-legend-80",attrs:{"width":"100%","type":"donut","options":_vm.options,"series":_vm.settings.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }